import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`options`}</strong><br />{`array option objects`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`options is an array of option objects, which have `}<em parentName="td">{`label`}</em>{` and `}<em parentName="td">{`value`}</em>{` properties. `}<em parentName="td">{`label`}</em>{` is a string, `}<em parentName="td">{`value`}</em>{` can be a string, a number or a boolean. `}<em parentName="td">{`label`}</em>{` is what is displayed, `}<em parentName="td">{`value`}</em>{` is the value that will be passed when the control changes. If `}<em parentName="td">{`label`}</em>{` and `}<em parentName="td">{`value`}</em>{` are identical, instead of an object a simple string can be used.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      